import React from 'react';
/**
 * SVG Definition for small section break.
 */

export var OwnUpMobileBreak = function OwnUpMobileBreak() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "330",
    height: "9",
    viewBox: "0 0 330 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 6.70474C36.7026 2.05357 78.221 -0.648399 115.636 2.10987C156.475 5.12056 195.172 8.67288 237.48 7.8901C268.577 7.31469 298.002 3.54856 329 2.66517",
    strokeWidth: "2"
  }));
};